import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MomentModule } from 'angular2-moment';
import { NgSlimScrollModule } from "../../../node_modules/ngx-slimscroll/src/ngx-slimscroll/module/ngx-slimscroll.module";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TooltipModule } from 'ngx-bootstrap';
import { CountoModule } from 'angular2-counto';
import { BusyModule } from 'angular2-busy';

import { BrightServeModule } from "app/brightserve/brightserve.module";
import { AuthGuard } from "app/brightserve/auth-guard";
import { SharedModule } from "app/shared/shared.module";

import { AdminUserService } from './adminuser.service';

import { AdminUserProfileComponent } from './profile/adminuser-profile.component';

const UserRoutes: Routes = [
    { path: 'adminuser/:id', component: AdminUserProfileComponent, canActivate: [AuthGuard] }
];

@NgModule({
	imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(UserRoutes),
        NgbModule,
        MomentModule,
        BrightServeModule,
        SharedModule,
        NgSlimScrollModule,
        InfiniteScrollModule,
        TooltipModule.forRoot(),
        CountoModule,
        BusyModule
	],
	declarations: [
        AdminUserProfileComponent
    ],
    providers: [
        AdminUserService
    ]
})
export class AdminUserModule { }



// WEBPACK FOOTER //
// ./src/app/adminuser/adminuser.module.ts